














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ViewSlideViewsModal from './ViewSlideViews.modal.vue'
import { EventBus } from '@/utils/event-bus'
import { saveAs } from 'file-saver'
import axios from 'axios'

@Component({
  components: {
    ViewSlideViewsModal
  }
})
export default class OverviewSlides extends Vue {
  @Prop() dateTo?: Date;
  @Prop() dateFrom?: Date;
  @Prop() marketKey?: string;
  @Prop() markets?: any;
  @Prop() componentReadyCount?: number;
  slides: any = []
  fields: any[] = [{ key: 'product', label: 'Product' }, { key: 'pageNo', label: 'Page Number', class: 'text-center' }, { key: 'title', label: 'Slide Deck' }, { key: 'downloadCount', label: 'Downloads', class: 'text-center' }, { key: 'downloadCustomCount', label: 'Custom Deck Downloads', class: 'text-center' }, { key: 'totalDownloads', label: 'Total Downloads' }]
  @Watch('markets')
  @Watch('dateTo')
  @Watch('dateFrom')
  @Watch('marketKey')
  async getSlides () {
    const eventType = 7
    await this.$store.dispatch('getPageViews', { dateTo: this.dateTo, dateFrom: this.dateFrom, eventType: eventType, marketKey: this.marketKey }).then((res: any) => {
      this.slides = res
      this.$emit('increment')
    })
  }

  formatDate (date: string) {
    // format date with time
    return new Date(date).toLocaleString()
  }

  get currentMarket () {
    const market = this.markets.find((market: any) => market.value === this.marketKey)
    return market.text
  }

  get topSlides () {
    if (!this.slides.length) return []
    const sortedSlides = [...this.slides].sort((a: { totalCount: number }, b: { totalCount: number }) => b.totalCount - a.totalCount)
    return sortedSlides.slice(0, 20)
  }

  async downloadSlide (slide: any) {
    EventBus.$emit('show-loader')
    const resp = await axios.post(`slide-deck-pages/download/${slide.slideDeckKey}`, { pageNo: slide.pageNo, trackingKey: slide.trackingKey }, { withCredentials: true, responseType: 'blob' })
    if (!resp || resp.status !== 200) {
      EventBus.$emit('hide-loader')
      return
    }
    const _blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' })
    saveAs(_blob, 'Slide download.pptx')
    this.slides.find((s: any) => s.key === slide.key).count++
    this.slides.find((s: any) => s.key === slide.key).totalCount++
    EventBus.$emit('hide-loader')
  }
}
